var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_html.js
// module id = 308
// module chunks = 168707334958949